import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Spinner } from '@adop/ui';
import { errorMessage } from '../lib/api';

/**
 * Renders a QR code as an <img> using the `qrcode` package. The package encodes
 * the value into a canvas/data URL; we keep the value (a table URL) as the only
 * input so the image can never drift from the token.
 */
export function QrCodeImage({
  value,
  size = 220,
  alt,
}: {
  value: string;
  size?: number;
  alt: string;
}) {
  const [src, setSrc] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setSrc(null);
    setError(null);
    QRCode.toDataURL(value, {
      width: size * 2,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: { dark: '#18181b', light: '#ffffff' },
    })
      .then((url) => {
        if (active) setSrc(url);
      })
      .catch((cause: unknown) => {
        if (active) setError(errorMessage(cause));
      });
    return () => {
      active = false;
    };
  }, [value, size]);

  if (error) {
    return <p className="text-sm text-red-600">{error}</p>;
  }
  if (!src) {
    return (
      <div
        className="flex items-center justify-center rounded-lg border border-zinc-200 bg-white"
        style={{ width: size, height: size }}
      >
        <Spinner />
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      className="rounded-lg border border-zinc-200 bg-white"
    />
  );
}
